import { CropScalesVM } from "./vm/scale"

export function updateScalesOnYearChanged(scales: CropScalesVM[], updatedScale: CropScalesVM) {

    const cropScales = scales.filter(s => (s != updatedScale) && (s.crop == updatedScale.crop))

    cropScales.forEach(s => {
        s.years = s.years.filter(y1 => updatedScale.years.every(y2 => y1 != y2))
    })

}
